var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.44922C4.66 9.44922 0 10.6192 0 12.9492L0 14.6992L14 14.6992V12.9492C14 10.6192 9.34 9.44922 7 9.44922ZM2.34 12.6992C3.18 12.1192 5.21 11.4492 7 11.4492C8.79 11.4492 10.82 12.1192 11.66 12.6992L2.34 12.6992ZM7 7.69922C8.93 7.69922 10.5 6.12922 10.5 4.19922C10.5 2.26922 8.93 0.699219 7 0.699219C5.07 0.699219 3.5 2.26922 3.5 4.19922C3.5 6.12922 5.07 7.69922 7 7.69922ZM7 2.69922C7.83 2.69922 8.5 3.36922 8.5 4.19922C8.5 5.02922 7.83 5.69922 7 5.69922C6.17 5.69922 5.5 5.02922 5.5 4.19922C5.5 3.36922 6.17 2.69922 7 2.69922ZM14.04 9.50922C15.2 10.3492 16 11.4692 16 12.9492V14.6992H20V12.9492C20 10.9292 16.5 9.77922 14.04 9.50922ZM13 7.69922C14.93 7.69922 16.5 6.12922 16.5 4.19922C16.5 2.26922 14.93 0.699219 13 0.699219C12.46 0.699219 11.96 0.829219 11.5 1.04922C12.13 1.93922 12.5 3.02922 12.5 4.19922C12.5 5.36922 12.13 6.45922 11.5 7.34922C11.96 7.56922 12.46 7.69922 13 7.69922Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamManagementIcon);
export default __webpack_public_path__ + "static/media/TeamManagementIcon.e1271829.svg";
export { ForwardRef as ReactComponent };